import { Script } from "gatsby"

const Intellimize = () => {
  /**
   * The default value in Intellimize’s script was 4000(ms), but their docs
   * explain that this could cause a page speed concern and it did! Setting this
   * higher than zero will cause the page to show a white screen for up to the
   * timeout value.
   *
   * The tradeoff is you won’t see content change during an A/B test. If Marketing
   * wants to start implementing A/B tests, we may want to make this configurable
   * on a page-by-page basis.
   *
   * https://help.intellimize.com/hc/en-us/articles/360036019854-Install-the-Webflow-Optimize-snippet
   */
  const FLICKER_TIMEOUT = 0
  return (
    <>
      {`<!-- Intellimize start -->`}
      <style>{`.anti-flicker, .anti-flicker * {visibility: hidden !important; opacity: 0 !important;}`}</style>
      <script>{`(function(e,t,p){var n=document.documentElement,s={p:[],r:[]},u={p:s.p,r:s.r,push:function(e){s.p.push(e)},ready:function(e){s.r.push(e)}};e.intellimize=u,n.className+=" "+p,setTimeout(function(){n.className=n.className.replace(RegExp(" ?"+p),"")},t)})(window, ${FLICKER_TIMEOUT}, 'anti-flicker')`}</script>
      <link as="script" href="https://cdn.intellimize.co/snippet/117419923.js" rel="preload" />
      <Script
        src="https://cdn.intellimize.co/snippet/117419923.js"
        async
        onError={() => {
          document.documentElement.className = document.documentElement.className.replace(/ ?anti-flicker/, "")
        }}
      />
      <link crossOrigin="anonymous" href="https://api.intellimize.co" rel="preconnect" />
      <link href="https://117419923.intellimizeio.com" rel="preconnect" />
      <link crossOrigin="anonymous" href="https://log.intellimize.co" rel="preconnect" />
      {`<!-- Intellimize end -->`}
    </>
  )
}

export default Intellimize
